<template>
  <div>
    <div class="row">
      <button class="btn btn-success" @click.prevent="add"><i class="fas fa-plus"></i></button>
    </div>
    <hr />
    <div v-if="fields.length === 0">
      Nessun campo aggiunto
    </div>
    <div class="form-row mb-2" v-for="(field, index) in fields">
      <div class="col-auto">
        <input class="form-control" type="text" :name="`fields[${index}][key]`" placeholder="Chiave" v-model="field.key">
      </div>
      <div class="col-auto">
        <input class="form-control" type="text" :name="`fields[${index}][title]`" placeholder="Titolo" v-model="field.title"/>
      </div>
      <div class="col-auto">
        <button @click.prevent="configure(index)" class="btn btn-primary">Configura</button>
      </div>
      <input v-for="option in field.options" type="hidden" :name="`fields[${index}][options][]`" :value="option" />
      <div class="col row justify-content-end">
        <div class="col-auto btn-group">
          <button @click.prevent="moveUp(index)" :disabled="index === 0" class="btn btn-outline-success"><i class="fas fa-arrow-up"></i></button>
          <button @click.prevent="moveDown(index)" :disabled="(index + 1) === fields.length" class="btn btn-outline-success"><i class="fas fa-arrow-down"></i></button>
        </div>
        <div class="col-auto">
          <button @click.prevent="remove(index)" class="btn btn-danger"><i class="fas fa-times"></i></button>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
  export default {
    name: "DynamicInsertForm",
    data() {
      return {
        fields: this.previousFields,
      }
    },
    props: {
      previousFields: {
        type: Array,
      }
    },
    methods: {
      add() {
        this.fields.push({
          title: "",
          options: []
        });
      },
      remove(index) {
        this.fields.splice(index, 1);
      },
      moveUp(index) {
        const b = this.fields[index - 1];
        Vue.set(this.fields, index - 1, this.fields[index]);
        Vue.set(this.fields, index, b);
      },
      moveDown(index) {
        const b = this.fields[index + 1];
        Vue.set(this.fields, index + 1, this.fields[index]);
        Vue.set(this.fields, index, b);
      }
    }
  }
</script>

<style scoped>

</style>
